import { activeScopeKey } from '@features/account-view/active';
import type { OrderListParams } from './list-params';

export const orderKeys = {
  all: ['orders'] as const,
  lists: () => [...orderKeys.all, 'list'] as const,
  /* EN-4396: list, count and detail keys carry the level and division filter. */
  list: (params: OrderListParams) =>
    [...orderKeys.lists(), params, activeScopeKey()] as const,
  pageDatas: () => [...orderKeys.all, 'page-data'] as const,
  pageData: (params: OrderListParams) =>
    [...orderKeys.pageDatas(), params, activeScopeKey()] as const,
  detail: (orderId: string | undefined) =>
    [...orderKeys.all, 'detail', orderId, activeScopeKey()] as const,
  /* EN-4204: keyed by the order's Postgres id (pg_id), which these routes take. */
  plan: (orderId: string) => [...orderKeys.all, 'plan', orderId] as const,
  providerActivity: (orderId: string) =>
    [...orderKeys.all, 'provider-activity', orderId] as const,
  /* Without `lineId`: every line's, for refetching them all after an edit. */
  candidates: (orderId: string, lineId?: string) =>
    [
      ...orderKeys.all,
      'candidates',
      orderId,
      ...(lineId === undefined ? [] : [lineId]),
    ] as const,
  routingTrail: (orderId: string) =>
    [...orderKeys.all, 'routing-trail', orderId] as const,
  /* Keyed by the payload: the answer only holds for the address that was sent. */
  addressValidation: (payload: unknown) =>
    [...orderKeys.all, 'address-validation', payload] as const,
  logs: (orderId: string | undefined) =>
    [...orderKeys.all, 'logs', orderId] as const,
  /* EN-4188: keyed by the order's Postgres id. */
  labelOptions: (orderId: string) =>
    [...orderKeys.all, 'label-options', orderId] as const,
  /* EN-4544: keyed by the order's Postgres id and the package and node rated. */
  rates: (orderId: string, query: unknown) =>
    [...orderKeys.all, 'rates', orderId, query] as const,
  /* EN-4188: the tab's buys and voids that wait for FedEx; client-only, keyed by the order's Postgres id. */
  pendingLabels: (orderId: string) =>
    [...orderKeys.all, 'pending-labels', orderId] as const,
  statusCounts: (params: OrderListParams) =>
    [...orderKeys.all, 'status-counts', params, activeScopeKey()] as const,
  overview: () => [...orderKeys.all, 'overview'] as const,
  live: (organizationId: string | undefined) =>
    [...orderKeys.all, 'live', organizationId] as const,
  autocomplete: (search: string | undefined) =>
    [...orderKeys.all, 'autocomplete', search] as const,
  publicOrder: (token: string | null) =>
    [...orderKeys.all, 'public', token] as const,
  feeds: (filter: unknown) => [...orderKeys.all, 'feeds', filter] as const,
  exports: (filter: unknown) => [...orderKeys.all, 'exports', filter] as const,
  batches: (status: string) => [...orderKeys.all, 'batches', status] as const,
  addressSuggestion: (address: unknown) =>
    [...orderKeys.all, 'address-suggestion', address] as const,
};
